export default function ({ app }) {
  if (process.client) {
    app.router.onReady(() => {
      window.addEventListener('popstate', () => {});

      if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
        let isFirstPage = true;

        app.router.afterEach(() => {
          isFirstPage = false;
        });

        window.addEventListener('popstate', (event) => {
          if (isFirstPage && window.history.length <= 1) {
            return;
          }

          if (window.history.length > 1) {
            event.preventDefault();
            app.router.back();
          }
        });
      }
    });

    document.addEventListener('backbutton', (event) => {
      event.preventDefault();
      
      if (window.history.length > 1) {
        app.router.back();
      } else {
        app.router.push('/');
      }
    }, false);
  }
}
